export default {"src":"/_next/static/media/compute.5858b3a2.svg","height":107,"width":107};